module.exports = __webpack_public_path__ + "img/logo.677af7dd.png";